import i18n from 'i18next'

const base = (locale) => {
    if (Intl && Intl.NumberFormat) {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'EUR',
        })
    } else {
        // fallback if not browser support for Intl or Intl.NumberFormat
        return {
            format: (value) => {
                return `${value}\xa0€` // \xa0 = &nbsp;
            },
        }
    }
}

const defaultOptions = {
    zeroDecimals: false,
}

export const CurrencyFormatter = {
    ...base,

    // extend default format by adding options
    format: (value, options = defaultOptions) => {
        let res = base(i18n.language === 'en' ? 'en-US' : 'fi-FI').format(value)

        // \xa0 = &nbsp;
        res = !options.zeroDecimals
            ? (i18n.language === 'en')
                ? res.replace(',', '\xa0').replace('.00', '')
                : res.replace(',00\xa0', '\xa0').replace('.00\xa0', '\xa0')
            : res

        return res
    }
}
